import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, eur } from "@/pages/mrv/mrvApi";
import OutcomeBadge from "@/pages/rc/OutcomeBadge";
import MRVLayout from "@/pages/mrv/MRVLayout";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";

const FILTERS = [
  { v: "all", l: "Tutti" },
  { v: "calcolabile", l: "Calcolabile" },
  { v: "riservato_direzione", l: "Riservato Direzione" },
  { v: "non_ammissibile", l: "Non Ammissibile" },
  { v: "draft", l: "Bozza" },
  { v: "emailed", l: "Inviati" },
];

export default function MRVQuotes() {
  const [quotes, setQuotes] = useState([]);
  const [status, setStatus] = useState("all");
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const load = () => {
    const params = {};
    if (status !== "all") params.status = status;
    if (q) params.q = q;
    api.get("/quotes", { params }).then((r) => setQuotes(r.data));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  return (
    <MRVLayout>
      <div data-testid="mrv-quotes-page">
        <h1 className="font-display text-3xl font-semibold tracking-tight text-stone-900 mb-1">Storico Preventivi</h1>
        <p className="text-stone-500 text-sm mb-6">Ricerca e filtra i preventivi Multirischi Volontariato.</p>

        <div className="flex flex-wrap gap-3 mb-5">
          <div className="relative flex-1 min-w-[220px]">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" strokeWidth={1.5} />
            <Input data-testid="mrv-quotes-search" placeholder="Cerca per numero preventivo…"
              value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
              className="pl-9 rounded-sm bg-white" />
          </div>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger data-testid="mrv-quotes-filter" className="w-56 rounded-sm bg-white"><SelectValue /></SelectTrigger>
            <SelectContent>
              {FILTERS.map((f) => (<SelectItem key={f.v} value={f.v}>{f.l}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>

        <div className="bg-white border border-stone-200 rounded-sm shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-stone-100 text-stone-500 text-xs uppercase tracking-wide">
                <th className="text-left font-medium px-5 py-2.5">Numero</th>
                <th className="text-left font-medium px-5 py-2.5">Ente</th>
                <th className="text-left font-medium px-5 py-2.5">Operatore</th>
                <th className="text-right font-medium px-5 py-2.5">Premio</th>
                <th className="text-left font-medium px-5 py-2.5 pl-8">Esito</th>
              </tr>
            </thead>
            <tbody>
              {quotes.map((qt) => (
                <tr key={qt.id} data-testid={`mrv-quote-row-${qt.id}`}
                  onClick={() => navigate(`/multirischi-volontariato/preventivi/${qt.id}`)}
                  className="border-b border-stone-100 hover:bg-stone-50 cursor-pointer">
                  <td className="px-5 py-3 font-mono text-stone-700">{qt.quote_number}</td>
                  <td className="px-5 py-3 text-stone-700">{qt.organization_name || "—"}</td>
                  <td className="px-5 py-3 text-stone-500">{qt.operator_name}</td>
                  <td className="px-5 py-3 text-right font-mono">{eur(qt.premium_result?.gross_total)}</td>
                  <td className="px-5 py-3 pl-8"><OutcomeBadge status={qt.calc_status} /></td>
                </tr>
              ))}
              {quotes.length === 0 && (
                <tr><td colSpan={5} className="px-5 py-10 text-center text-stone-400">Nessun preventivo trovato.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </MRVLayout>
  );
}
